export const SEARCH_SERVICE_ENDED_ERROR_CONTENT = {
  title: 'AI 콘텐츠 추천 기능이 종료되었습니다.',
  message: '앱 업데이트 후 디스커버의 더 다양한 기능을 이용해 보세요.',
} as const;
